interface EvaluatedPlayer {
  name: string;
  logoUrl?: string;
  link?: string;
  attendanceType: string;
}

interface ProjectEvaluatedPlayersCardProps {
  players: EvaluatedPlayer[];
}

export function ProjectEvaluatedPlayersCard({
  players,
}: ProjectEvaluatedPlayersCardProps) {
  return (
    <div className="border border-[#7846ff] rounded-[10px] overflow-clip h-[292px] w-full">
      <div className="flex flex-col gap-[20px] items-start p-[30px] h-full">
        {/* Title */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[16px] whitespace-pre">
          Players avaliados em seleção:
        </p>

        {/* Players List */}
        <div className="flex flex-col gap-[20px] items-start w-full">
          {players.length > 0 ? (
            players.map((player, index) => (
              <div
                key={index}
                className="flex gap-[17px] items-center w-full"
              >
                {/* Player Logo */}
                <div className="w-[53px] h-[53px] rounded-full bg-[#15203C] flex items-center justify-center overflow-hidden shrink-0">
                  {player.logoUrl ? (
                    <img
                      src={player.logoUrl}
                      alt={player.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-white text-lg font-semibold">
                      {player.name.charAt(0)}
                    </span>
                  )}
                </div>

                {/* Player Info */}
                <div className="flex flex-col gap-[3px] items-start">
                  {player.link ? (
                    <a
                      href={player.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-['Plus_Jakarta_Sans'] font-semibold leading-normal text-white text-[12px] w-[252px] hover:text-[#7846FF] transition-colors"
                    >
                      {player.name}
                    </a>
                  ) : (
                    <p className="font-['Plus_Jakarta_Sans'] font-semibold leading-normal text-white text-[12px] w-[252px]">
                      {player.name}
                    </p>
                  )}
                  <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-white text-[12px] whitespace-pre">
                    {player.attendanceType}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-[#888888] text-[14px]">
              Nenhum player avaliado
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
